/**
 * "Catalog linked" (BLU-1268): marks one of the org's suppliers that is linked
 * to a PrintRun catalog supplier. Provenance, not a state, so it takes the
 * brand tint (`bg-primary/10 text-primary-strong`, DESIGN.md section 1) with
 * the Link2 glyph of the cross-org provenance language (section 13), never a
 * StatusPill tone. The words carry the meaning; the glyph is decorative.
 */
import { useTranslation } from 'react-i18next';
import { Link2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function CatalogLinkedPill({ className }: { className?: string }) {
  const { t } = useTranslation('inventory');
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-md bg-primary/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary-strong',
        className,
      )}
    >
      <Link2 className="h-2.5 w-2.5 shrink-0" aria-hidden="true" />
      {t('supplierCatalog.linkedPill')}
    </span>
  );
}
